/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pll_New_Product_Sources_TitleInputs */

const vi_pll_new_product_sources_title = /** @type {(inputs: Pll_New_Product_Sources_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô thành phẩm nguồn (túi lẻ)`)
};

/**

* @param {Pll_New_Product_Sources_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pll_new_product_sources_title = /** @type {((inputs?: Pll_New_Product_Sources_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pll_New_Product_Sources_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pll_new_product_sources_title(inputs)
});